module.exports = __webpack_public_path__ + "img/cba.471b8273.png";